import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThqdepartmentService {

  constructor(private _http:HttpClient,private router:Router) { }

  AllTHQDepartments():Observable<any>{

    let FullUrl = localStorage.getItem('BaseUrl') +"/api/THQ/GetTHQDepartments";
    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };

    return this._http.get(FullUrl,requestOptions );
  }


  AddNewTHQDepartment(Name:string, Code:string,IsActive:any):Observable<any>{

    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };
    let FullUrl = localStorage.getItem('BaseUrl')+"/api/THQ/CreateTHQDepartment";
    let data = {DepartmentName:Name, TypeCode: Code,IsActive: IsActive}
    return this._http.post(FullUrl,data,requestOptions);
  }

  UpdateTHQDepartment(data):Observable<any>{

    const headerDict = {
      'Access-Control-Allow-Origin':'*',
      "Authorization": "Bearer " + localStorage.getItem('access_token'),
      'Accept': 'application/json'
    }
    const requestOptions = {                                                                                                                                                                                 
      headers: new HttpHeaders(headerDict), 
    };
    let FullUrl = localStorage.getItem('BaseUrl')+"/api/THQ/UpdateTHQDepartment";
    return this._http.post(FullUrl,data,requestOptions);
  }

}
